import React from 'react';
import { Link } from 'react-router-dom';

// Presentational Component
const SharePost = () => {
	return (
		<div>
			<h2 className="tasks_sharepost">Share a Post</h2>

			<h3><Link to='/api/Posts#post-post-id-share'>POST /v1/post/{'{id}'}/share</Link></h3>
			<p>This endpoint will share a post to one or more social channels.</p>

			<h4> Usage </h4>
			<p> Sending this request requires authorization. You must also have the ID of the post you wish to share.</p>

			<p><strong>Note:</strong> The default setting for <strong>shareType</strong> is <strong><em>Auto</em></strong>, which lets the system schedule the shares. <strong>requestedShareDates</strong> is only allowed when the share type is set to <em>Manual</em>.
			</p>
			<h4> Example Request Object </h4>
			<pre className="language-javascript"><code className="language-javascript">{`{
	id: "794775b6-520e-4fa1-9a88-8c668a6149c8",
	shareType: "Manual",
	requestedShareDates: "2012-04-21T18:25:43-05:00",
	userChannelIds: [100, 202, 340],
	comment: "Hey! Check out this awesome content!"
}`}
			</code></pre>
		</div>
	);
};

export default SharePost;


// WEBPACK FOOTER //
// ./src/components/getting-started/simpleTasks/SharePost.js